export default __webpack_public_path__ + "static/media/isinet.0b3c4358.svg";